import { User } from '../context/AuthContext'

// Known legacy plan labels from the old subscription-based pricing
const LEGACY_PLAN_LABELS = [
    'Riskless-monthly',
    'Riskless-yearly',
    'Essential-monthly',
    'Essential-yearly',
    'Professional-monthly',
    'Professional-yearly',
    'Private',
]

// Legacy subscriber = has an active legacy plan (subscription-based)
// Only treat as legacy when they have an actual legacy plan_label.
// New clients with no plan_label always get the per-job pricing flow.
export const isLegacySubscriber = (user: User): boolean => {
    return !!user.plan_label && LEGACY_PLAN_LABELS.includes(user.plan_label)
}

// New pricing user = no active legacy subscription
export const isNewPricingUser = (user: User): boolean => {
    return !isLegacySubscriber(user)
}
